/**
 * @file Shared helper for presentation modes (Slideshow, Virtual Field Trip)
 */
import type { PresentationMode, PresentationPage } from '@@/types/presentation'
import { PresentationPageType } from '@@/types/presentation'

const buildPresentationLink = ({
  showLink,
  page,
  searchParams,
  mode = 'slideshow',
}: {
  showLink: string
  page: PresentationPage
  searchParams?: ConstructorParameters<typeof URLSearchParams>[0]
  mode?: PresentationMode
}): string => {
  const pageUrlSuffix = ((): string => {
    switch (page.pageType) {
      case PresentationPageType.Section:
        return `/section/${page.sectionId}`
      case PresentationPageType.Group:
        return `/group/${page.groupId}`
      case PresentationPageType.Wish:
        return `/wish/${page.wishId}`
      case PresentationPageType.Cover:
      default:
        return ''
    }
  })()

  const normalizedShowLink = showLink.replace(/\/+$/, '')
  const baseUrl = new URL(`${normalizedShowLink}/${mode}${pageUrlSuffix}`)
  if (searchParams != null) {
    for (const [key, value] of new URLSearchParams(searchParams)) {
      baseUrl.searchParams.set(key, value)
    }
  }
  return baseUrl.toString()
}

// Index of the cover page in the flat page list.
const COVER_PAGE_INDEX = 0

// Convert a post's entity ID to its CID (content identifier).
const getCurrentPostCid = (entityId: string): string => `c${entityId}`

export { buildPresentationLink, COVER_PAGE_INDEX, getCurrentPostCid }
export type { PresentationMode, PresentationPage }
export { PresentationPageType }
